import { fetcher } from '@commenda/utils';
import { CreateCustomerPayload, CustomerCreateResponse } from './types';

export async function createCustomer(body: CreateCustomerPayload): Promise<{
  success: boolean;
  data?: {
    data: CustomerCreateResponse;
  };
  error?: string;
}> {
  try {
    const response = await fetcher(
      'new-sales-tax/customers',
      {
        method: 'POST',
        body,
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to create customer',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
